import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine.js";
import LoggedInBoilerplate from "../LoggedInBoilerplate.js";
import LoadingSection from "../../../helperComponents/LoadingSection.js";
import CustomButton from "../../../helperComponents/CustomButton.js";
import { BiPlus } from "react-icons/bi";
import getSubPath from "../../../../controllers/getSubPath.js";
import getImageURL from "../../../../controllers/getImageURL.js";
import goTo from "../../../../controllers/goTo.js";
import { RiEdit2Line } from "react-icons/ri";
import Context from "../../../../Context.js";
import DetailsSection from "./EmployeeDetailsSection.js";
import IconWithTextForPageHeader from "../../../customUiForCs/IconWithTextForPageHeader.js";
import NomenclatureOfComment from "../nomenclature/NomenclatureOfComment.js";
import NomenclatureOfDispute from "../nomenclature/NomenclatureOfDispute.js";
import NomenclatureOfAbsence from "../nomenclature/NomenclatureOfAbsence.js";
import NomenclatureOfVacation from "../nomenclature/NomenclatureOfVacation.js";
import ProfileQuickActionPopup from "../../../customUiForCs/profileQuickAction/ProfileQuickActionPopup.js";
import AssignmentHistoryForUserProfile from "../../../customUiForCs/tabularAssignmentHistory/AssignmentHistoryForUserProfile.js";
import { MdNumbers } from "react-icons/md";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 300px;
  gap: 20px;
  margin-top: 50px;
  width: 100%;
  align-items: center;
`;

const Column1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: calc(100vw - 600px);

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Image = styled.img`
  object-fit: cover;
  width: 200px;
  border-radius: 500px;
  height: 200px;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 0 14px;
  margin-right: 10px;
`;

const Title = styled.div`
  font-size: 25px;
  font-weight: 900;
  color: var(--accent);

  text-align: center;
  text-transform: uppercase;
`;

const Desc = styled.div`
  font-size: 12px;
  text-transform: capitalize;
  color: var(--elementDim);
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const TopSection = styled.div`
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  overflow: hidden;
  width: 800px;
  padding: 20px;

  @media (max-width: 900px) {
    flex-direction: column;
    width: 100%;
    padding: 20px;
    justify-content: center;
    align-items: center;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: 15px;
`;

const PrimaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-wrap: wrap;
`;

const BubbleText = styled.div`
  padding: 5px 25px;
  background-color: var(--surface);
  font-size: 14px;
  border-radius: 10px;
  color: var(--elementDim);
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
`;

const SecondaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  flex-wrap: wrap;
`;

const SecondSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const RowSection1 = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const ColumnSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* justify-content: space-between; */
  width: 100%;
`;

export default function EmployeeProfile({ onClick }) {
  const { setForm } = useContext(Context);

  const [item, setItem] = useState(null);
  const [itemID, setItemID] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let newItemID = getSubPath(1);
    setItemID(newItemID);
  }, []);

  useEffect(() => {
    if (itemID) loadProfile();
  }, [itemID]);

  let core = null;

  let titleLine1 = null;
  let titleLine2 = null;

  if (loading) {
    titleLine1 = "Profil";
    titleLine2 = "De l'employé";

    core = <LoadingSection />;
  } else {
    if (!item) return null;

    titleLine1 = item.lastName;
    titleLine2 = item.firstName;

    if (titleLine1) titleLine1 = titleLine1.toUpperCase();
    if (titleLine2) titleLine2 = titleLine2.toUpperCase();

    core = (
      <Container>
        <Column1>
          <TopSection>
            <Image src={getImageURL(item.profileImage, true)}></Image>

            <Right>
              <PrimaryLine>
                <Title>
                  {item.lastName} {item.firstName}
                </Title>
              </PrimaryLine>
              <SecondaryLine>
                <IconWithTextForPageHeader
                  icon={<MdNumbers />}
                  permissionName="registrationNumberPermissions"
                >
                  Matricule : {item.registrationNumber}
                </IconWithTextForPageHeader>
              </SecondaryLine>

              <Buttons>
                <CustomButton
                  onClick={goTo(`/edit-employee/?itemID=${item._id}`)}
                  icon={<RiEdit2Line />}
                ></CustomButton>
                <CustomButton
                  onClick={handleQuickAction("ABSENCE")}
                  // onClick={goTo(`/add-absence/?userID=${item._id}`)}
                  icon={<BiPlus />}
                >
                  Absence
                </CustomButton>
                <CustomButton
                  onClick={handleQuickAction("DISPUTE")}
                  // onClick={goTo(`/add-dispute/?userID=${item._id}`)}
                  icon={<BiPlus />}
                >
                  Contentieux
                </CustomButton>
                <CustomButton
                  onClick={handleQuickAction("VACATION")}
                  // onClick={goTo(`/add-vacation/?userID=${item._id}`)}
                  icon={<BiPlus />}
                >
                  Congés
                </CustomButton>
                <CustomButton
                  onClick={handleQuickAction("COMMENT")}
                  // onClick={goTo(`/add-comment/?userID=${item._id}`)}
                  icon={<BiPlus />}
                >
                  Commentez
                </CustomButton>
              </Buttons>
            </Right>
          </TopSection>

          <DetailsSection item={item} />

          <RowSection1>
            <ColumnSection>
              <NomenclatureOfDispute userID={itemID} />

              <NomenclatureOfComment userID={itemID} />
            </ColumnSection>

            <ColumnSection>
              <NomenclatureOfAbsence userID={itemID} />
              <NomenclatureOfVacation userID={itemID} />
            </ColumnSection>
          </RowSection1>

          <RowSection1>
            <AssignmentHistoryForUserProfile userID={itemID} />
          </RowSection1>
        </Column1>
      </Container>
    );
  }

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={titleLine1}
      titleLine2={titleLine2}
    >
      {core}
    </LoggedInBoilerplate>
  );

  function handleQuickAction(sectionType) {
    return () => {
      setForm({
        title: `Ajouter des informations`,
        component: (
          <ProfileQuickActionPopup
            defaultSectionType={sectionType}
            userID={itemID}
            callback={loadProfile}
          />
        ),
      });
    };
  }

  async function loadProfile() {
    setLoading(true);
    let data = await serverLine.get(`/employee/?itemID=${itemID}`);
    setItem(data);
    setLoading(false);
  }
}
